export default "__VITE_ASSET__Byvxw9TS__"